/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "d5b2918b5d23dbb118d611ae7f2e5967ac2317b9";
